export default {
  alignSelfCenter: {
    alignSelf: 'center',
  },
};
